/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Snackbar } from '../../components/index'
import Detail from './detail/index'
import { WebApi } from '../../api/web'
import { userId } from '../../services/authentication'
import { Errors } from '../../utilities/error'
const DetailLawer = () => {
  const { id } = useParams()
  const [lawyer, setLawyer] = useState(null)
  const [like, setLike] = useState(false)
  const [loading, setLoading] = useState(false)
  const [countLike, setCountLike] = useState(0)
  const [lastComments, setLastComments] = useState(null)
  const [amount, setAmount] = useState(null)
  const [type, setType] = useState(4)
  const [serviceId, setServiceId] = useState(null)
  const [consultingService, setConsultingService] = useState([])
  const [typeWork, setTypeWork] = useState(null)

  useEffect(() => {
    getLawyer()
  }, [])
  useEffect(() => {
    if (localStorage.getItem('serviceType') != 'null') {
      setType(Number(localStorage.getItem('serviceType')))
    }
    LastComments()
  }, [])

  const getLawyer = async () => {
    await WebApi.lawyer(id)
      .then((res) => {
        setLawyer(res.data.data.lawyer)
        setCountLike(res.data.data.lawyer.likes.length)
        res.data.data.lawyer.likes.map((userLike) => {
          if (userLike == userId()) {
            setLike(true)
          }
        })
      })
      .catch((err) => {})
  }

  const LastComments = async () => {
    await WebApi.comments(id, 1)
      .then((res) => {
        setLastComments(res.data.data.comments.comments)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    setAmount(null)
    ConsultingServiceList()
  }, [type])

  const ConsultingServiceList = async () => {
    setLoading(true)
    await WebApi.consultingServiceList(
      id,
      type,
      localStorage.getItem('serviceLawyer')
    )
      .then((res) => {
        setConsultingService(res.data.data.consultingServiceList)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  const LikeDisLike = async () => {
    setLoading(true)
    await WebApi.likeDislike(id)
      .then((res) => {
        setLoading(false)
        if (res.data.data.likeLawyer.message == 1) {
          setCountLike(countLike + 1)
          setLike(true)
        } else {
          setCountLike(countLike - 1)
          setLike(false)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const OrderConsulting = async () => {
    if (amount) {
      setLoading(true)
      localStorage.setItem('currentLawyerId', id)
      await WebApi.orderConsulting(serviceId)
        .then((res) => {
          setLoading(false)
          window.location.href = res.data.data.orderConsultingService.url
        })
        .catch((err) => {
          setLoading(false)
          Snackbar({
            title: 'نا موفق',
            message: Errors[err.response.data.errors[0].message],
            type: 'danger',
          })
        })
    }
  }

  return (
    <>
      <Detail
        {...{
          id,
          lawyer,
          like,
          loading,
          countLike,
          lastComments,
          LikeDisLike,
          amount,
          setAmount,
          OrderConsulting,
          consultingService,
          setServiceId,
          setType,
          type,
          typeWork,
          setTypeWork,
        }}
      />
    </>
  )
}
export default DetailLawer
